<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' ref='form' :inline='true' :model='queryForm' class='query-form' label-width='80px'
                 size='small' @submit.native.prevent>
            <el-form-item label='互动'>
                <el-input v-model='queryForm.interactId' style='width: 200px'></el-input>
            </el-form-item>
            <el-form-item label='用户'>
                <GridSelect
                    :columns="USER_code"
                    :limit='1'
                    :searchs="USER_search"
                    :value='queryForm.userId'
                    dataListUrl='/mpp/user/findList'
                    entityBeanName='mppUser'
                    labelName='userName'
                    labelValue='id'
                    placeholder='请选择用户'
                    queryEntityUrl='/mpp/user/get'
                    size='small'
                    style='width: 200px'
                    title='选择用户'
                    @getValue='getValue'
                >
                </GridSelect>
            </el-form-item>
            <el-form-item>
                <el-button icon='el-icon-search' size='small' type='primary' @click='getMarketInteractRecordList'>查询
                </el-button>
                <el-button icon='el-icon-refresh' size='small' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <!--                    <el-button-->
                    <!--                        type='primary'-->
                    <!--                        size='small'-->
                    <!--                        icon='el-icon-plus'-->
                    <!--                        @click='addMarketInteractRecord'-->
                    <!--                    >新建-->
                    <!--                    </el-button>-->
                    <!--                    <el-button-->
                    <!--                        type='warning'-->
                    <!--                        plain-->
                    <!--                        size='small'-->
                    <!--                        icon='el-icon-edit'-->
                    <!--                        :disabled='multipleSelection.length != 1'-->
                    <!--                        @click='editMarketInteractRecord(null)'-->
                    <!--                    >修改-->
                    <!--                    </el-button>-->
                    <el-button
                        :disabled='multipleSelection.length <= 0'
                        icon='el-icon-delete'
                        plain
                        size='small'
                        type='danger'
                        @click='deleteMarketInteractRecord(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               :http-request='upload'
                               :show-file-list='true'
                               action='#'
                               class='upload-demo'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        class='icon-box'
                        title='搜索'
                        @click='search'
                    >
                      <Icon color='#606266'>
                        <Search />
                      </Icon>
                    </span>
                    <!--                    <span-->
                    <!--                        title='下载模板'-->
                    <!--                        class='icon-box'-->
                    <!--                        @click='importTemplate'-->
                    <!--                    >-->
                    <!--                      <Icon color='#606266'>-->
                    <!--                        <ArrowDown />-->
                    <!--                      </Icon>-->
                    <!--                    </span>-->
                    <!--                    <span-->
                    <!--                        class='icon-box'-->
                    <!--                        title='导入数据'-->
                    <!--                        @click='isImport'-->
                    <!--                    >-->
                    <!--                      <Icon color='#606266'>-->
                    <!--                        <ArrowExportUp24Regular />-->
                    <!--                      </Icon>-->
                    <!--                    </span>-->
                    <!--                    <span-->
                    <!--                        title='导出数据'-->
                    <!--                        class='icon-box'-->
                    <!--                        @click='exportMarketInteractRecordList'-->
                    <!--                    >-->
                    <!--                      <Icon color='#606266'>-->
                    <!--                        <ArrowDownload24Regular />-->
                    <!--                      </Icon>-->
                    <!--                    </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMarketInteractRecordList'
                    >
                      <Icon color='#606266'>
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :cell-style="{padding: '9px'}"
                :data='marketInteractRecordList'
                :header-cell-style="{padding: '10px'}"
                :header-row-style="{height: '10px'}"
                :row-style="{height: '9px'}"
                border
                height='100%'
                row-key='id'
                size='small'
                @selection-change='handleSelectionChange'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='用户'
                    prop='userId'
                >
                    <template v-if='scope.row.user' slot-scope='scope'>
                        <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
                        <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
                        <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
                        <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='创建时间'
                    prop='createTime'
                ></el-table-column>

                <el-table-column
                    align='center'
                    fixed='right'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click='checkMarketInteractRecord(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <!--                            <div @click='editMarketInteractRecord(scop.row.id)'>-->
                            <!--                                <Icon size='16'>-->
                            <!--                                    <Edit24Regular />-->
                            <!--                                </Icon>-->
                            <!--                                <span class='operation-label'>修改</span>-->
                            <!--                            </div>-->
                            <div @click='deleteMarketInteractRecord(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    :current-page.sync='currentPage'
                    :page-size='pageSize'
                    :page-sizes='[10, 20, 50, 100]'
                    :pager-count='7'
                    :total='totalNum'
                    background
                    layout='total, sizes, prev, pager, next, jumper'
                    @size-change='sizeChange'
                    @current-change='currentChange'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='marketInteractRecordStates[marketInteractRecordState]'
                :visible.sync='showDialog'
                width='60%'
                :append-to-body="true"
                @close='closeDialog'
            >
                <div>
                    <el-form
                        ref='marketInteractRecordForm'
                        :inline='true'
                        :model='marketInteractRecord'
                        :rules='rules'
                        label-width='120px'
                        size='small'
                    >
                        <el-form-item
                            label='互动ID'
                            prop='interactId'
                        >
                            <el-input
                                v-model='marketInteractRecord.interactId'
                                :disabled="marketInteractRecordState == 'check'"
                                size='small'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='用户'
                            prop='userId'
                        >
                            <GridSelect
                                :columns="USER_code"
                                :disabled="marketInteractRecordState == 'check'"
                                :limit='1'
                                :searchs="USER_search"
                                :value='marketInteractRecord.userId'
                                dataListUrl='/mpp/user/findList'
                                entityBeanName='mppUser'
                                labelName='userName'
                                labelValue='id'
                                placeholder='请选择用户'
                                queryEntityUrl='/mpp/user/get'
                                size='small'
                                style='width: 200px'
                                title='选择用户'
                                @getValue='getValueForm'
                            >
                            </GridSelect>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        v-if="marketInteractRecordState != 'check'"
                        type='primary'
                        @click='submitForm'
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Delete24Regular,
    Edit24Regular,
    Eye24Regular
} from '@v2icons/fluent';
import { ArrowDown, ArrowUp, GridDots, Printer, Refresh, Search } from '@v2icons/tabler';
import { deleteFun, exprotExcel, get, importDate, importTemplate, post } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant'
export default {
    components: {
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMarketInteractRecordList();
                this.getMarketInteractRecordList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMarketInteractRecordList();
                this.getMarketInteractRecordList();
                this.$emit('resetCheckState');
            }
        }
    },
    props: {
        interactId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            queryForm: {
                interactId: '', //互动ID
                userId: '' //用户ID
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            marketInteractRecordState: 'add',
            marketInteractRecordStates: {
                add: '新建互动有礼记录',
                check: '查看互动有礼记录',
                edit: '修改互动有礼记录'
            },

            multipleSelection: [],
            marketInteractRecordList: [],
            marketInteractRecord: {
                interactId: '', //互动ID
                userId: '' //用户ID
            },
            btnLoading: false,

            rules: {
                interactId: [{ required: true, message: '互动ID不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMarketInteractRecordList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.marketInteractRecordList = [];
        },
        resetDialog() {
            this.marketInteractRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                interactId: '', //互动ID
                userId: '' //用户ID
            };
            this.getMarketInteractRecordList();
        },
        closeDialog() {
            this.showDialog = false;
            this.marketInteractRecord = {
                interactId: '', //互动ID
                userId: '' //用户ID
            };
        },
        submitForm() {
            if (this.marketInteractRecordState == 'add') {
                this.$refs.marketInteractRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/interactrecord/add`, { ...this.marketInteractRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketInteractRecordList();
                                this.resetDialog();
                                this.getMarketInteractRecordList();
                            }
                        });
                    }
                });
            } else if (this.marketInteractRecordState == 'edit') {
                this.$refs.marketInteractRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/interactrecord/edit`, { ...this.marketInteractRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketInteractRecordList();
                                this.resetDialog();
                                this.getMarketInteractRecordList();
                            }
                        });
                    }
                });
            }
        },
        addMarketInteractRecord() {
            this.showDialog = true;
            this.marketInteractRecordState = 'add';
        },
        checkMarketInteractRecord(marketInteractRecordId) {
            console.log(marketInteractRecordId);
            this.currentMarketInteractRecordId = marketInteractRecordId;

            this.getMarketInteractRecordById();
            this.showDialog = true;
            this.marketInteractRecordState = 'check';
        },
        editMarketInteractRecord(marketInteractRecordId) {
            console.log('marketInteractRecord', marketInteractRecordId);
            if (marketInteractRecordId) {
                this.currentMarketInteractRecordId = marketInteractRecordId;
                this.getMarketInteractRecordById();
            } else {
                this.marketInteractRecord = { ...this.marketInteractRecord, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.marketInteractRecordState = 'edit';
        },
        deleteMarketInteractRecord(marketInteractRecordId) {
            let ids = '';
            if (marketInteractRecordId) {
                ids = marketInteractRecordId;
            } else {
                ids = this.multipleSelection.map((marketInteractRecord) => marketInteractRecord.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/market/interactrecord/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMarketInteractRecordList();
                            this.getMarketInteractRecordList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMarketInteractRecordList() {
            this.resetMarketInteractRecordList();
            this.getMarketInteractRecordList();
        },
        getMarketInteractRecordList(query = {}) {
            this.loading = true;
            get(`/market/interactrecord/findList`, {
                ...this.queryForm,
                interactId: this.interactId,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.marketInteractRecordList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMarketInteractRecordById() {
            get(`/market/interactrecord/get`, { id: this.currentMarketInteractRecordId }).then((res) => {
                if (res.success) {
                    this.marketInteractRecord = { ...this.marketInteractRecord, ...res.marketInteractRecord };
                }
            });
        },
        /**
         * 导出信息
         */
        exportMarketInteractRecordList() {
            //this.btnLoading = true;
            exprotExcel(`/market/interactrecord/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/market/interactrecord/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/market/interactrecord/importData`, formData);
            this.refreshMarketInteractRecordList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMarketInteractRecordList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMarketInteractRecordList();
        },
        getValue(value) {
            this.queryForm.userId = value;
        },
        getValueForm(value) {
            this.marketSign.userId = value;
        }
    }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>